import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getBackOrders(requestData) {
    return axios.post(ENV.appointmentApiBase + "/backorder/list", requestData, this.requestConfig());
  }

  static exportBackOrders(requestData) {
    return axios.post(ENV.appointmentApiBase + "/backorder/export/enqueue", requestData, this.requestConfig());
  }
}

export default Service;
